import { swSettings } from "app/common/services/swSettings";
import {
    SEGMENTS_GROUP_TOTAL_METRICS,
    SEGMENTS_TOTAL_METRICS,
} from "app/components/widget/widget-utilities/segments/constants";
import { get } from "lodash";

export const getShouldHideSegments = () => {
    const isSegmentsAvailable = !get(swSettings, "components.CustomSegments.isAllowed", false);

    return isSegmentsAvailable;
};

export const getSegmentsMetricWithTotalTraffic = () => {
    const groupMetrics = Object.keys(SEGMENTS_GROUP_TOTAL_METRICS);
    const singleMetrics = Object.keys(SEGMENTS_TOTAL_METRICS);

    return [...groupMetrics, ...singleMetrics];
};

export const DEFAULT_DURATION_FOR_SEGMENTS = "6m";

export const DISABLED_DURATIONS = ["25m", "37m", "custom"];

export const DISABLED_PRESETS_BEFORE_LIMIT_SEGMETNS = ["37m", "custom"];
export const DISABLED_PRESETS_AFTER_LIMIT_SEGMETNS = ["25m", "37m", "custom"];
export const MAX_ALLOWED_DURATION_BEFORE_LIMIT_SEGMENTS = "25m";
export const MAX_ALLOWED_DURATION_AFTER_LIMIT_SEGMENTS = "12m";

export const WW_DISABLED_PRESETS_BEFORE_LIMIT_SEGMETNS = ["25m", "37m", "custom"];
export const WW_DISABLED_PRESETS_AFTER_LIMIT_SEGMETNS = ["12m", "25m", "37m", "custom"];
export const WW_MAX_ALLOWED_DURATION_BEFORE_LIMIT_SEGMENTS = "12m";
export const WW_MAX_ALLOWED_DURATION_AFTER_LIMIT_SEGMENTS = "6m";
